import React, { useRef, useState } from 'react';
import Intl from '@fx-ui/intl';
import { Button, Column, Drawer, VirtualTable } from '@fx-ui/fine-design';
import { calcTableColumnWidth, concat, get, post, redirect } from '~/utils';
import ResizeObserver from 'rc-resize-observer';

interface IImportFailDetailProps {
    visible: boolean;
    onClose: () => void;
    token?: string;
    exportApi: string;
    columns: (Omit<Column, 'width'> & { width?: number; minWidth?: number })[];
    tableData: any[];
}

const ImportFailDetail = (props: IImportFailDetailProps) => {
    const { visible, token, exportApi, columns, tableData, onClose } = props;

    const exportUrlMapRef = useRef<Record<string, string>>({});
    const [tableWidth, setTableWidth] = useState(0);

    const downloadFailDetail = () => {
        if (!token) return;

        const exportUrlMap = exportUrlMapRef.current;
        if (exportUrlMap[token]) {
            redirect(exportUrlMap[token]);
            return;
        }
        post(exportApi, {
            token
        }).then((res) => {
            const url = get(res, 'data.url');
            exportUrlMap[token] = url;
            redirect(url);
        });
    };

    const getColumns = () => {
        return calcTableColumnWidth(
            concat(
                [
                    {
                        fixed: true,
                        title: Intl.get('trigger.log.failure.index'),
                        width: 48,
                        dataIndex: 'rowIndex',
                        render: (_v: unknown, _r: unknown, rowIndex: number) => rowIndex + 1
                    }
                ],
                columns
            ),
            tableWidth - 12
        ) as Column[]; // 滚动条宽度默认12px
    };

    return (
        <Drawer
            className="fx-member-import-result-drawer"
            visible={visible}
            title={Intl.get('invite.import.fail.detail')}
            onClose={onClose}
        >
            <div className="import-result-wrapper">
                <div className="import-fail-detail">
                    <div className="detail-header">
                        <Button
                            type="primary"
                            onClick={() => {
                                downloadFailDetail();
                            }}
                        >
                            {Intl.get('invite.failList.download')}
                        </Button>
                        <div className="expire-tip">
                            {Intl.get('invite.failList.download.expire.tip')}
                        </div>
                    </div>
                    <ResizeObserver
                        onResize={({ width }) => {
                            setTableWidth(width);
                        }}
                    >
                        <VirtualTable
                            className="detail-table"
                            columns={getColumns()}
                            dataSource={tableData}
                            fixedHeader
                            hasCellBorder
                        />
                    </ResizeObserver>
                </div>
            </div>
        </Drawer>
    );
};

export default ImportFailDetail;
